export default __webpack_public_path__ + "static/media/domain.07983b5c.png";